import config from "@/config"
import helper from  "@/vueHelper"

let formatters = {
    Link(link) {
        let func = function (row, cell, value, columnDef, dataContext) {
            let val = value||"";
            if (link) {
                var matches = link.match(/{.+?}/g)
                var temp = _.cloneDeep(link);
                console.log(dataContext);
                if (matches) {
                  for (var m = 0; m < matches.length; m++) {
                    
                    temp = temp.replace(matches[m], dataContext[matches[m].replace('{', '').replace('}', '')])
                  }
                }
             }
            return `<a href=${temp}>${val}</a>`;
        }


        return func;

    },
    inboxLink(link,valField) {
        let func = function (row, cell, value, columnDef, dataContext) {
            return `<a href=${link}/${value}>${dataContext[valField]}</a>`;
        }
        return func;
    },
    ListFormatter(list) {
        
        let func = function (row, cell, value, columnDef, dataContext) {
            let val = value;
            if(Array.isArray(list)){
                let find = list.find(o=>o.Value == val);
                if(find){
                    val = find.Key;
                }
            }
            return val;
        }
        return func;
    },
    DateFormatter(row, cell, value, columnDef, dataContext) {
        if (value == null) {
            return "";
        }
        else {
            var val = value.split("T");
            if (val.length == 2) {
                if (val[1] == "00:00:00") {
                    return val[0];
                } else {
                    return val[0] + " " + val[1];
                }
            } else {
                return val;
            }
        }
    },
    DateTimeFormatter(row, cell, value, columnDef, dataContext) {
        if (value == null) {
            return "";
        }
        else {
            //date only
            return helper.formatDatetime(value);
           
        }
    },
    CheckmarkFormatter(row, cell, value, columnDef, dataContext) {
        //return value ? '✔' : '';
        return value ? '<i class="icofont-ui-check"></i>' : '';
    },
}



export default formatters;


